import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert"; // Import
import {
  openAdvtModal,
  advtBanners,
  loadAdvtData,
  deleteAdvertisement,
} from "ActionsAdvertisement";
import { showError, showSuccess } from "ReduxErrorBar";
import {BASE_IMAGES_URL, COMMON_FAIL_MESSAGE ,ACCESS_FILES_API_KEY} from "Constants";
import LocaleStrings from "Languages";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

class ListItem extends Component {
  constructor(props) {
    super(props);
  }

  editAdvt = () => {
    let { record } = this.props;

    this.props.openAdvtModal({ showModal: true });
    this.props.loadAdvtData(record);
  };

  deleteAdvt = () => {
    let { record, session } = this.props;
    let pageNo = this.props.currentPage;
    if (this.props.pageDataLength == 1) {
      pageNo = pageNo;
    }

    confirmAlert({
      title: LocaleStrings.button_delete,
      message: LocaleStrings.advt_delete_confirmation_text,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            var advtid = record.advtid;
            this.props.deleteAdvertisement(session, advtid, (result) => {
              if (result.error) {
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                this.props.showSuccess(LocaleStrings.advt_delete_success_alert);
                this.props.pagination(pageNo);
              }
            });
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    var { record, advtBannerOptions } = this.props;
    var screen = _.filter(advtBannerOptions, (obj) => {
      return obj.value == record.screen;
    });

  let  imagePreviewUrl = `${BASE_IMAGES_URL}/${record.bannerimg}?api_key=${ACCESS_FILES_API_KEY}`;
        

    return (
      <tr>
        {/* <td className="">
        {record.isenabled == false ? ( 
          <div style={{display:'flex'}}>
           
            <i className="fa fa-exclamation-circle banner-disable"  style={{color: "red" ,marginTop:3,marginRight:4,cursor:'pointer'}}><span style={{marginTop:'-30px'}} className="bannerdisable-text">Banner is disabled</span></i>
            <span>{record.advtname}</span>
          </div>
          
        ):(<span>{record.advtname}</span>)}
        </td> */}
        <td className="">
        <div
          className="row"
          style={{ display: "flex", paddingLeft: 20, paddingTop: 3 }}
          >
        <img
            style={{ width: '100px', height: '75px' }}
            src={imagePreviewUrl}
        />
         
          {record.isenabled == false ? (
            <div>
              <OverlayTrigger
                key="refresh"
                placement="top"
                overlay={
                  <Tooltip id="tooltip-manage">
                    <span className="tag-label-effect-time">
                      {LocaleStrings.advt_banner_disabled}
                    </span>
                  </Tooltip>
                }
              >
                <i
                  className="fa fa-exclamation-circle"
                  aria-hidden="true"
                  style={{ color: "red", margin: 7, cursor: "pointer" }}
                ></i>
              </OverlayTrigger>
              <span>{record.advtname}</span>
            </div>
          ) : (
            <span>{record.advtname}</span>
          )}
           </div>
        </td>

        <td>{screen.length > 0 ? screen[0].name : ""}</td>
        <td>
          <div className="action-button-area">
            <div className="action-button vcenter">
              <button
                className="btn btn-custom-table-white"
                onClick={this.editAdvt}
              >
                {LocaleStrings.button_edit}
              </button>
            </div>
            <div className="action-button vcenter">
              <button
                className="i-custom-table-delete"
                onClick={this.deleteAdvt}
              >
                <img
                  className="button-delete-icon"
                  src="../../style/images/delete.png"
                />
              </button>
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    advtBannerOptions: state.advtBannerOptions,
  };
}
export default connect(mapStateToProps, {
  openAdvtModal,
  advtBanners,
  loadAdvtData,
  deleteAdvertisement,
  showError,
  showSuccess,
})(ListItem);
